$( window ).on('load', function() {
    $('.ready').removeClass('ready');
});

$( document ).ready(function() {
	let theVariable = 0;    
});

// Set element height as the window height
function heightResize( element_obj ) {
    window_height = $( window ).height();
    element_obj.css( 'height', window_height );
}

// Scroll to the target - use data-target on the trigger
function scrollMe( target, offset, duration ) {
    offset = typeof offset !== 'undefined' ? offset : 0;
    duration = typeof duration !== 'undefined' ? duration : 800;
    if( target ) {
        $('html, body').stop(true, false).animate({
            scrollTop: $( '#' + target ).offset().top - offset
        }, duration);
    }
}



const faders = document.querySelectorAll(".fadeIn");
const sliders = document.querySelectorAll(".slideIn");
const faderDown = document.querySelectorAll(".fadeInDown");
const lineExpanders = document.querySelectorAll(".lineExpand");
const unveilMe = document.querySelectorAll(".unveil");


const appearOptions = {
    root: null,
    threshold: 0,
    rootMargin: "0px 0px -100px 0px",
    breakpoints: {
        768: {
            rootMargin: "0px 0px -250px 0px"
        },
    },
};

const appearOnScroll = new IntersectionObserver(function(entries, appearOnScroll) {
    entries.forEach(entry => {
        if (!entry.isIntersecting){
            return;
        } else {
            entry.target.classList.add("appear");
            appearOnScroll.unobserve(entry.target);
        }
    });
}, appearOptions);

faders.forEach(fader => {
    appearOnScroll.observe(fader);
});

sliders.forEach(slider => {
    appearOnScroll.observe(slider);
});

faderDown.forEach(faderDown => {
    appearOnScroll.observe(faderDown);
});

lineExpanders.forEach(lineExpander => {
    appearOnScroll.observe(lineExpander);
});

unveilMe.forEach(unveilMe => {
    appearOnScroll.observe(unveilMe);
});

var mouseTarget = document.querySelectorAll('#moduleCard1, #moduleCard2, #moduleCard3');

mouseTarget.forEach(mouseTarget => {
   
    mouseTarget.addEventListener('mouseenter', e => {
    
        if(mouseTarget.classList.contains('gradient-down')) {
            mouseTarget.classList.remove('gradient-down');
            mouseTarget.classList.add('gradient-up');
        } else {
            mouseTarget.classList.remove('gradient-up');
            mouseTarget.classList.add('gradient-down');
        }
    })
    
})

$('.submit-action').on('click', function(e) {
    e.preventDefault();

    var formData = $('#info-request').serializeArray();
    console.log(formData);

    $.ajax({
        type: "post",
        url: "/functions.php",
        data:formData,
        dataType: "json",
        error: function(jqXHR, textStatus, errorThrown) {
            // sweetAlert('', jqXHR.responseJSON.message, jqXHR.responseJSON.message_type);      
            alert('error');
            var responseText = jQuery.parseJSON(jqXHR.responseText);
            console.log(responseText);    
        },
        success: function (data) {
            sweetAlert('', data.message, data.message_type);    
            $('#info-request')[0].reset();

            console.log("Great Success!");
        }
    });

});